<template>
  <database-management-modal :element="department" ref="modal">
    <template v-slot:body>
      <div class="form-group" :class="{ 'has-error' : $v.selectedDepartment.$error }">
        <p>Where would you like to move the users in this department?</p>
        <label class="control-label">* Department</label>
        <selectize
          class="form-control selectize selectize-single"
          name="department"
          v-model="selectedDepartment"
          :options="handleDepartmentOptions()"/>

        <vuelidate-help :field="$v.selectedDepartment" label="Department" />
      </div>
    </template>
    <template v-slot:footer>
      <ladda-button :click="saveDepartment" type="button" class="btn btn-lg btn-primary pull-right" data-dismiss="modal"><i class="fa fa-check"></i> Save</ladda-button>
    </template>
  </database-management-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import VuelidateHelp from '../../misc/VuelidateHelp'
import { http, notify } from 'utils'
import DatabaseManagementModal from './templates/DatabaseManagementModal'
import DepartmentSelection from '../../misc/DepartmentSelection'
import Selectize from '../../ext/codium/CodiumSelectize'

export default {
  components: {
    DatabaseManagementModal,
    DepartmentSelection,
    VuelidateHelp,
    Selectize
  },

  data () {
    return {
      selectedDepartment: []
    }
  },

  props: {
    department: {
      required: true
    },
    departments: {
      required: true
    },
    users: {
      required: true
    }
  },

  methods: {
    handleDepartmentOptions () {
      return this.departments.filter((x) => x !== this.department).map((x) => {
        x['text'] = x['name']
        return x
      })
    },

    hasErrorClass (field, classes) {
      return field.$error ? `${classes} has-error` : `${classes}`
    },

    closeModal () {
      this.$refs.modal.closeModal()
    },

    async saveDepartment () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.reject(new Error('Data invalid'))
      }

      http.delete(`departments/${this.department.id}`, { params: { selectedDepartment: this.selectedDepartment } })
        .then((resp) => {
          this.$emit('added', resp.data.data)
          notify.success('Successully moved users and deleted the department.')
          this.closeModal()
        })
    }
  },

  validations () {
    return {
      selectedDepartment: {
        required
      }
    }
  }
}
</script>
